export default {
    getCodingInformation: (state) => {
        return state.codingInformation
    },
    allergiesGetters: (state) => (storeKey: string, field: string) => {
        return  state.allergiesDataByKey[storeKey] ? state.allergiesDataByKey[storeKey][field] : null
    }
}
